export default "__VITE_ASSET__D04KS$ti__";